
export const EnumExtensions = {
	getNamesAndValues<T extends number>(e: any): EnumValue<T>[] {
		return EnumExtensions.getNames(e).map(function (n: string) { return ({ name: n, value: e[n] as T }); });
	},

	getMappedNamesAndValues<T extends number>(e: any, getName: (t: T) => string): EnumValue<T>[] {
		return EnumExtensions.getValues<T>(e).map(x => ({ name: getName(x), value: x as T }));
	},

	getNames(e: any) {
		return EnumExtensions.getObjValues(e).filter(v => typeof v === 'string') as string[];
	},

	getValues<T extends number>(e: any): T[] {
		return EnumExtensions.getObjValues(e).filter(v => typeof v === 'number') as T[];
	},

	getObjValues(e: any): (number | string)[] {
		return Object.keys(e).map(k => e[k]);
	}
};

export class EnumValue<T> {
	name: string;
	value: T;
}
